import { faBook } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Button, Col, Container, Row, Spinner } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../hooks';
import { EditEntityQuery, loadEntity, selectEntityStateStatus } from '../redux/EntitySlice';
import { setTaxonomyType } from '../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../redux/TaxonomyVersionSlice';
import { UserRoleEnum, selectAuthorizedEntities, selectUser, selectUserRole } from '../redux/UserSlice';
import CanShowGiven29ReportAccess from './feature/CanShowGiven29ReportAccess';
import CanShowGiven939ReportAccess from './feature/CanShowGiven939ReportAccess';
import CanShowGivenAfrReportAccess from './feature/CanShowGivenAfrReportAccess';
import CanShowGivenAuthorizedContactUserRoles from './feature/CanShowGivenAuthorizedContactUserRoles';
import { EntityContactRole, EntityUserRole } from '../redux/ContactSlice';
import MenuTile from './core/MenuTile';
import { faScaleUnbalancedFlip } from '@fortawesome/free-solid-svg-icons';
import { faScaleUnbalanced } from '@fortawesome/free-solid-svg-icons';


const EntityMenu = () => {

    const dispatch = useAppDispatch();
    const user = useAppSelector(selectUser);
    const userRoleSelector = useAppSelector(selectUserRole);
    const authorizedEntitiesSelector = useAppSelector(selectAuthorizedEntities);
    const entityStateStatusSelector = useAppSelector(selectEntityStateStatus);


    React.useEffect(() => {

        if (userRoleSelector && userRoleSelector == UserRoleEnum.EntityUser) {
            if (authorizedEntitiesSelector) {
                if (authorizedEntitiesSelector.length == 1) {
                    var entityCode = authorizedEntitiesSelector[0].code;
                    if (entityCode) {
                        var eQuery: EditEntityQuery = {
                            entityId: entityCode,
                            taxonomyYear: -1
                        };
                        dispatch(loadEntity(eQuery));
                    }
                }
            }
        }

    }, [user])

    React.useEffect(() => {

        dispatch(setTaxonomyType(TaxonomyTypeEnum.AFR));

    }, []);

    return (
        <Container fluid>
            <Spinner children={''} style={{ width: '1rem', height: '1rem' }}
                type="grow" color="warning"
                hidden={entityStateStatusSelector == "idle"} />
            <div hidden={entityStateStatusSelector != "idle"}>
                <Row style={{
                    paddingTop: '2em',
                    display: "flex",
                    alignContent: "flex-start",
                    columnGap: "2em"
                }}>
                    <CanShowGivenAfrReportAccess
                        ignoreRole={true}
                    >
                        <MenuTile tileLink="/EntityAFRManagement"
                            tileTitle="AFR Management"
                            tileDescription="Used to review AFR Records" icon="bi bi-ui-checks" />
                    </CanShowGivenAfrReportAccess>

                    <MenuTile tileLink="/PublicReportsMenu"
                        tileTitle="Reports"
                        tileDescription="Launch Reports for selected AFRs" icon="bi bi-journal-arrow-down" />
                    <a href={"https://myfloridacfo.com/division/aa/local-governments"} target="_blank">
                        <Button className="taskLinkButton" style={{
                            borderRadius: '1em',
                            textAlign: 'center',
                            height: '13em',
                            width: '20em',
                            marginBottom: '2em',
                        }}>
                            <i className={"bi"} style={{ fontSize: '5.5rem' }}>
                                <FontAwesomeIcon
                                    style={{}} icon={faBook} />
                            </i>
                            <Row>
                                <Col>
                                    <h4>Manuals</h4>
                                </Col>
                            </Row>

                        </Button>
                    </a>
                    <CanShowGivenAuthorizedContactUserRoles
                        entityContactRole={EntityContactRole.PRIMARY}
                        entityUserRole={EntityUserRole.EDITOR}
                        reportAccess={null}
                    >
                        <MenuTile tileLink="/EntityManagement"
                            tileTitle="Entity Management"
                            tileDescription="Edit a Local Goverment Entity" icon="bi bi-bank" />
                    </CanShowGivenAuthorizedContactUserRoles>

                    <CanShowGiven939ReportAccess>
                        <MenuTile tileLink="/939CourtReporting"
                            tileTitle="939.185 Court Reporting"
                            tileDescription="Used to upload and review 939.185 Court Reports"
                            icon={<FontAwesomeIcon className="menuIcon" icon={faScaleUnbalancedFlip} />}
                            tileType="fontawesome" />
                    </CanShowGiven939ReportAccess>

                    <CanShowGiven29ReportAccess>
                        <MenuTile tileLink="/29CourtReporting"
                            tileTitle="29.0085 Court Reporting"
                            tileDescription="Used to upload and review 29.0085 Court Reports"
                            icon={<FontAwesomeIcon className="menuIcon" icon={faScaleUnbalanced} />}
                            tileType="fontawesome" />
                    </CanShowGiven29ReportAccess>
                </Row>
            </div>
        </Container>
    );
}
export default EntityMenu;